/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17.31 7.48a1 1 0 011.41 0 1 1 0 010 1.42l-7.88 7.59a1 1 0 01-1.41 0l-4.11-4.2a1 1 0 111.42-1.4l3.43 3.5z"/>'
  }
})
